import { Node, mergeAttributes } from "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    plotlyChart: {
      appendPlotlyChart: (position?: number, attrs?: Partial<PlotlyChartNodeAttrs>) => ReturnType;
    };
  }
}

export type PlotlyChartNodeAttrs = {
  chartId: string;
  plotlyData: Record<string, unknown>[];
  plotlyLayout: Record<string, unknown>;
  chartType: string;
  width: number;
  height: number;
};

export const PLOTLY_CHART_WIDTH = 720;

export const PLOTLY_CHART_HEIGHT = 450;

export const PlotlyChart = Node.create({
  name: "plotlyChart",

  group: "block",

  atom: true,

  addAttributes() {
    return {
      chartId: {
        default: null,
      },
      plotlyData: {
        default: [],
        renderHTML(attrs) {
          return { "data-plotly-data": JSON.stringify(attrs.plotlyData) };
        },
        parseHTML(el) {
          try {
            return JSON.parse(el.getAttribute("data-plotly-data") ?? "[]") as Record<
              string,
              unknown
            >[];
          } catch {
            return [];
          }
        },
      },
      plotlyLayout: {
        default: {},
        renderHTML(attrs) {
          return { "data-plotly-layout": JSON.stringify(attrs.plotlyLayout) };
        },
        parseHTML(el) {
          try {
            return JSON.parse(el.getAttribute("data-plotly-layout") ?? "{}") as Record<
              string,
              unknown
            >;
          } catch {
            return {};
          }
        },
      },
      chartType: {
        default: null,
      },
      width: {
        default: PLOTLY_CHART_WIDTH,
      },
      height: {
        default: PLOTLY_CHART_HEIGHT,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "block-plotly-chart",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["block-plotly-chart", mergeAttributes(HTMLAttributes)];
  },

  addCommands() {
    return {
      appendPlotlyChart:
        (position, attrs) =>
        ({ commands, state }) => {
          return commands.insertContentAt(
            position !== undefined ? position : state.selection.$to.end(1),
            {
              type: this.name,
              attrs,
            },
          );
        },
    };
  },
});
